/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".truncated-text__block[_ngcontent-%COMP%]{display:flex;flex-direction:column}.truncated-text__button[_ngcontent-%COMP%]{display:flex;align-items:flex-end;justify-content:flex-end;align-content:flex-end;cursor:pointer;color:#00a3e0}"];
export { styles as styles };
